import React from 'react';
import { Building2, Home, Clock, Users } from 'lucide-react';
import { StatsCard } from './StatsCard';
import { useProperties } from '../../../hooks/useProperties';
import { useClients } from '../../../hooks/useClients';

export const StatsGrid: React.FC = () => {
  const { properties } = useProperties();
  const { clients } = useClients();

  const forSaleCount = properties.filter(p => p.status === 'for-sale').length;
  const forRentCount = properties.filter(p => p.status === 'for-rent').length;
  const forShortRentCount = properties.filter(p => p.status === 'for-short-rent').length;
  const clientsCount = clients.length;

  const stats = [
    {
      name: 'Ventes',
      value: forSaleCount,
      icon: Building2,
    },
    {
      name: 'Locations',
      value: forRentCount,
      icon: Home,
    },
    {
      name: 'Locations Courte Durée',
      value: forShortRentCount,
      icon: Clock,
    },
    {
      name: 'Clients Actifs',
      value: clientsCount,
      icon: Users,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <StatsCard
          key={stat.name}
          name={stat.name}
          value={stat.value}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};